import { titleCase } from "@memorang/helpers/common";
import type { MixedItemTag } from "@memorang/types";
import Icon from "@react-native-vector-icons/material-design-icons/static";
import type { CursorValue } from "react-native";
import { List, Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import { useDevice } from "../../../useDevice";
import AnswerStatusChip from "../../AnswerStatusChip";
import Box from "../../Box";

type ItemsListItemProps = {
	id: number;
	tags: MixedItemTag[];
	index: number;
	title: string;
	answerStatus: "correct" | "incorrect" | "skipped";
	marked?: boolean;
	isDetailView?: boolean;
};
const ItemsListItem = ({
	id,
	tags,
	index,
	title,
	answerStatus,
	marked,
	isDetailView,
}: ItemsListItemProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	const RenderTags = () => {
		const finalTags = isDetailView ? tags : tags.length > 0 ? [tags[0]] : [];

		return (
			<Box flexDirection="row" alignItems="center" gap={4} flexWrap="wrap">
				{finalTags.map((item) => {
					return (
						<Box
							key={item.id}
							style={{
								alignItems: "center",
								borderRadius: 4,
								backgroundColor: theme.colors.secondaryContainer,
								maxWidth: isDetailView || isMobile ? 350 : 200,
							}}
							paddingVertical={4}
							paddingHorizontal={8}
						>
							<Text variant="labelMedium" numberOfLines={1}>
								{item.code ? `${item.code} - ${item.label}` : item.label}
							</Text>
						</Box>
					);
				})}
			</Box>
		);
	};
	return (
		<List.Item
			style={{
				cursor: "default" as unknown as CursorValue,
			}}
			title={() => {
				return <Text variant="labelLarge">{`ITEM-${id}`}</Text>;
			}}
			left={(props) => (
				<List.Icon
					{...props}
					style={{
						...props.style,
						alignSelf: "flex-start",
						paddingTop: 1,
					}}
					icon={() => {
						return <Text variant="titleSmall">{`${index + 1}.`}</Text>;
					}}
				/>
			)}
			description={() => {
				return (
					<Box gap={8} paddingTop={4}>
						<Text
							variant="bodySmall"
							numberOfLines={2}
							style={{
								color: theme.colors.onSurfaceVariant,
							}}
						>
							{title}
						</Text>
						<RenderTags />
					</Box>
				);
			}}
			right={(props) => (
				<List.Icon
					{...props}
					icon={() => {
						return (
							<Box flexDirection="row" alignItems="center" gap={8}>
								{marked && (
									<Icon name="flag" size={18} color={theme.colors.error} />
								)}
								<AnswerStatusChip
									status={answerStatus}
									label={titleCase(answerStatus)}
									fontSize={12}
									minWidth={92}
									gap={4}
								/>
							</Box>
						);
					}}
				/>
			)}
		/>
	);
};

export default ItemsListItem;
